import firebase from 'firebase/app';
import moment from "moment-timezone";
import 'firebase/firestore';
import 'firebase/database';
import functions from '../firebase/functions';

export default ((originId, destinId, offset, copyMaps, copyCities, copyContacts, copyAdmins) => {
  const firestore = firebase.firestore();
  const groupsRef = firestore.collection('groups');

  groupsRef.doc(originId).collection("events").get().then((eventsSnap) => {
    eventsSnap.forEach((eventSnap) => {
      const event = eventSnap.data();

      const eventTime = event.location.date.toDate();
      const newTime = firebase.firestore.Timestamp.fromMillis(eventTime.getTime() + offset);
      event.location.date = newTime;
      delete event.ratings;
      delete event.subgroups;
      delete event.attendees;
      groupsRef.doc(destinId).collection("events").doc(eventSnap.id).set(event);
    });
  });

  groupsRef.doc(originId).collection("travels").get().then((eventsSnap) => {
    eventsSnap.forEach((eventSnap) => {
      const event = eventSnap.data();
      const travelOrigin = event.origin.date.toDate();
      const travelDestin = event.destin.date.toDate();

      event.origin.date = firebase.firestore.Timestamp.fromMillis(travelOrigin.getTime() + offset);
      event.destin.date = firebase.firestore.Timestamp.fromMillis(travelDestin.getTime() + offset);
      delete event.ratings;
      delete event.subgroups;
      delete event.attendees;

      groupsRef.doc(destinId).collection("travels").doc(eventSnap.id).set(event);
    });
  });

  const copyCitiesWithNewDates = () => {
    const collection = 'cities';
    groupsRef.doc(originId).collection(collection).get().then((eventsSnap) => {
      eventsSnap.forEach((document) => {
        const city = document.data();

        const arrivalDate = new Date(city.arrival_date);
        const departureDate = new Date(city.departure_date);

        arrivalDate.setTime(arrivalDate.getTime() + offset);
        departureDate.setTime(departureDate.getTime() + offset);

        city.arrival_date = moment(arrivalDate).tz("UTC").format("YYYY-MM-DD");
        city.departure_date = moment(departureDate).tz("UTC").format("YYYY-MM-DD");
        groupsRef.doc(destinId).collection(collection).doc(document.id).set(city);
      });
    });
  };

  const copyCollection = (collection) => {
    groupsRef.doc(originId).collection(collection).get().then((eventsSnap) => {
      eventsSnap.forEach((document) => {
        const data = document.data();
        groupsRef.doc(destinId).collection(collection).doc(document.id).set(data);
      });
    });
  };

  if (copyCities) {
    copyCitiesWithNewDates();
    copyCollection('countries');
  }
  if (copyMaps) {
    copyCollection('maps');
  }
  if (copyAdmins) {
    groupsRef.doc(originId).get().then((doc) => {
      const trip = doc.data();
      const admins = [];
      Object.entries(trip.user_ids).forEach(([key, isAdmin]) => {
        if (isAdmin) {
          admins.push(key);
        }
      });
      functions.addAdminsToTrip(destinId, admins);
    });
  }
  if (copyContacts) {
    const databaseRef = firebase.database().ref('groups/');
    databaseRef.child(originId).child('contacts').once('value').then((snapshot) => {
      databaseRef.child(destinId).child('contacts').update(snapshot.val());
    });
  }
});
